// extracted by mini-css-extract-plugin
export default {"form":"FormAuthorization_form__J062Q","loading":"FormAuthorization_loading__GgG3-","datepicker":"FormAuthorization_datepicker__mdHQA"};